import { useSermonSupport } from './common/useSermonSupport';
import SermonSupportResult from './SermonSupportResult';
import './AiService.scss';

const SERMON_PROCESS_STEPS = [
  { title: '1. 업로드', desc: '설교 원문을 업로드하거나 붙여넣습니다.' },
  { title: '2. AI 분석', desc: '핵심 메시지, 본문 흐름, 적용 포인트, 어울리는 찬양 주제를 한 번에 구조화합니다.' },
  { title: '3. 결과 생성', desc: '설교 요약·QT·소그룹 나눔지·AI찬양추천을 탭으로 바로 확인합니다.' },
];

export default function SermonSupportPage() {
  const workspace = useSermonSupport();
  const {
    sermonText, handleSermonTextChange,
    isUploading, isGenerating, isDragging,
    fileStatus, errorMessage,
    fileInputRef, uploadSectionRef,
    handleScrollToUpload,
    handleFileChange, handleDragOver, handleDragLeave, handleDrop,
    handleGenerate,
  } = workspace;

  return (
    <div className="AiService">
      <div className="container">

        <section className="hero">
          <div className="hero-card">
            <div className="hero-grid">
              <div>
                <div className="eyebrow">AI서비스 · 설교지원</div>
                <h1>
                  <span>설교 원문 업로드 한 번으로</span>
                  <br />
                  <span>설교요약·QT·나눔지·찬양추천까지</span>
                </h1>
                <p>설교 원문을 업로드하거나 붙여넣으면, AI가 설교 요약·QT 묵상·소그룹 나눔지·어울리는 적용찬양까지 한 번에 만들어 드립니다. 탭을 눌러 각 자료를 확인하세요.</p>
                <div className="hero-actions">
                  <button type="button" className="btn btn-primary" onClick={handleScrollToUpload}>
                    설교 원문 업로드하기
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <main className="sermonmain">
          <div className="section-grid">
            <section className="card" ref={uploadSectionRef}>
              <div className="section-title">
                <div>
                  <h2>설교 원문 업로드</h2>
                  <p>파일을 업로드하면 자동으로 텍스트를 추출합니다. 추출된 내용은 아래에서 직접 검토·수정할 수 있습니다.</p>
                </div>
              </div>

              <label
                className={`upload-zone${isDragging ? ' dragging' : ''}`}
                htmlFor="sermonSupportFile"
                onDragEnter={handleDragOver}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
              >
                <div className="upload-icon">⬆</div>
                <h3>{isUploading ? '텍스트 추출 중...' : '파일을 클릭하여 업로드'}</h3>
                <p>
                  설교 원문 PDF, DOCX, TXT 파일을 업로드하세요.<br />
                  텍스트를 자동으로 추출해 아래 입력창에 채워드립니다.
                </p>
                <div className="upload-actions">
                  <span className="btn btn-primary">파일 선택</span>
                </div>
                <div className="upload-hint">
                  <span className="pill">최대 30MB</span>
                  <span className="pill">PDF / DOCX / TXT</span>
                  <span className="pill">서버 미저장</span>
                </div>
              </label>
              <input
                id="sermonSupportFile"
                ref={fileInputRef}
                type="file"
                accept=".pdf,.docx,.txt"
                onChange={handleFileChange}
                disabled={isUploading}
              />
              <div className="footer-note">{fileStatus}</div>

              <textarea
                className="sermon-input"
                value={sermonText}
                onChange={(e) => handleSermonTextChange(e.target.value)}
                placeholder="파일을 업로드하거나 설교 본문을 직접 붙여넣어 주세요."
                rows={10}
              />

              <button
                type="button"
                className="btn btn-primary generate-button"
                onClick={handleGenerate}
                disabled={isGenerating || isUploading}
              >
                {isGenerating ? '생성 중...' : 'AI 자료 생성하기'}
              </button>

              {errorMessage && <p className="error-message">{errorMessage}</p>}

              <div className="process">
                {SERMON_PROCESS_STEPS.map((step) => (
                  <div className="process-step" key={step.title}>
                    <strong>{step.title}</strong>
                    <span>{step.desc}</span>
                  </div>
                ))}
              </div>

              <div className="footer-note">
                업로드 파일은 텍스트 추출 후 즉시 폐기되며 서버에 저장되지 않습니다.<br />
                생성에는 통상 10~20초 정도 소요됩니다.<br />
                AI 결과는 참고용이며 최종 검토·선곡은 목회자가 진행해주세요.
              </div>
            </section>

            <SermonSupportResult workspace={workspace} />
          </div>
        </main>

      </div>
    </div>
  );
}
